import React from 'react';
import { useCurrency } from './CurrencyContext';
import { WithCurrencyProps } from './WithCurrencyProps'; // Importamos la interfaz

// Higher-Order Component para manejar la conversión y los métodos on/off dentro del objeto currency
export const withCurrency = <P extends object>(Component: React.ComponentType<P & WithCurrencyProps>) => {
  return (props: P) => {
    const { currency } = useCurrency();

    // Función c para convertir el valor basado en la tasa de cambio
    const c = (value: number): number => {
      return Math.ceil((value * currency.rate) * 100) / 100;//value / currency.rate;
    };

    return <Component {...props} c={c} currency={currency} />;
  };
};